'use server'

import { apiRequest, ApiResponse } from '../request'

export type SuggestionConfidence = 'high' | 'medium' | 'low'

export interface SuggestionItem {
    id: number
    name: string
    wsim: number
    suggestedPrincipal: boolean
    currentTussCode: string | null
}

export interface SuggestionGroup {
    companyId: number
    category: string
    tussCode: string
    tussTerm: string
    confidence: SuggestionConfidence
    imagingRisk: boolean
    minWsim: number
    maxWsim: number
    principalId: number
    count: number
    applied: boolean
    items: SuggestionItem[]
}

export interface UnifySuggestionsResponse {
    engine: string | null
    note: string | null
    stats: Record<string, number> | null
    pendingGroups: number
    pendingItems: number
    groups: SuggestionGroup[]
}

export interface ApplySuggestionPayload {
    companyId: number
    targetId: number
    sourceIds: number[]
    tussCode: string
}

const BASE = 'catalog/unify-suggestions'

export async function getUnifySuggestions(): Promise<
    ApiResponse<UnifySuggestionsResponse>
> {
    return apiRequest<UnifySuggestionsResponse>(BASE, {})
}

export async function applyUnifySuggestion(
    data: ApplySuggestionPayload,
): Promise<ApiResponse<{ targetId: number; merged: number; tussCode: string; name: string }>> {
    return apiRequest(`${BASE}/apply`, { data }, 'post')
}

export interface FuseCrossFilialResult {
    groups: number
    mergedItems: number
    dryRun: boolean
}

/** Funde duplicatas reais entre filiais da org (master). dryRun só conta. */
export async function fuseCrossFilial(
    dryRun: boolean,
): Promise<ApiResponse<FuseCrossFilialResult>> {
    return apiRequest(
        'catalog/fuse-cross-filial',
        { params: { dryRun: dryRun ? 'true' : 'false' } },
        'post',
    )
}
